import React from 'react';
import { Flex, Text, Box } from 'rebass';
import { FaMinus, FaPlus } from "react-icons/fa";
// import NotReadyYetModal from 'gift-certificate/NotReadyYetModal';
import { AiOutlineTag } from "react-icons/ai";
// import useOutsideClick from 'use-onclickoutside';

export function OrderBreakDown({ orderSummary, isFromReadyPurchase }) {
    const showSubtotal = orderSummary?.lineItems.length > 1;

    return <Flex flexDirection="column" m="auto" maxWidth={700} mb={3} mt={4} >
        <Flex alignItems="center" mb={2} justifyContent="space-between">
            <Text
                ml={2}
                color="codGrey"
                fontFamily="Bitter"
                fontSize={20}
                fontWeight={400}
                lineHeight="100%"
                letterSpacing="-0.4px"
                textAlign="center"
                minWidth="max-content"
            >
                Order Summary
            </Text>
        </Flex>
        <Box>
            <Box px={2}>
                {orderSummary?.lineItems.map((lineItem) =>
                    <Flex justifyContent="space-between" my={1} >
                        <Text
                            color="codGrey"
                            fontSize={16}
                            fontFamily="Poppins"
                            lineHeight="150%"
                            fontWeight={400}
                            letterSpacing="-0.28px"
                            textAlign="left"
                        >
                            {lineItem?.description}
                        </Text>
                        <Text
                            color="codGrey"
                            fontFamily="Poppins"
                            fontSize={["16px", "18px"]}
                            fontStyle="normal"
                            fontWeight={400}
                            lineHeight="24px"
                            letterSpacing="-0.32px"
                            textAlign='right'
                            minWidth={100}
                        >
                            {lineItem?.['sub-total-without-discounts'] ? `$${parseFloat(lineItem?.['sub-total-without-discounts']).toFixed(2)}` : '-'}
                        </Text>
                    </Flex>
                )}
                {showSubtotal && <>
                    <Box my={1} sx={{
                        borderTop: "1px solid rgba(0, 0, 0, 0.05)"
                    }} />
                    <Flex justifyContent="end" my={1} sx={{ textDecorationLine: 'line-through' }}>
                        <Text
                            color="codGrey"
                            fontSize={16}
                            fontFamily="Poppins"
                            lineHeight="150%"
                            fontWeight={400}
                            letterSpacing="-0.28px"
                            textAlign="left"
                        >
                            Subtotal
                        </Text>
                        <Text
                            color="codGrey"
                            fontFamily="Poppins"
                            fontSize={["16px", "18px"]}
                            fontStyle="normal"
                            fontWeight={400}
                            lineHeight="24px"
                            letterSpacing="-0.32px"
                            textAlign='right'
                            minWidth={100}
                        >
                            {orderSummary?.['sub-total-without-discounts'] ? `$${parseFloat(orderSummary?.['sub-total-without-discounts']).toFixed(2)}` : '-'}
                        </Text>
                    </Flex>

                    <Flex justifyContent="end" my={1} >
                        <Text
                            color="codGrey"
                            fontSize={16}
                            fontFamily="Poppins"
                            lineHeight="150%"
                            fontWeight={400}
                            letterSpacing="-0.28px"
                            textAlign="left"
                        >
                            Bundle Price
                        </Text>
                        <Text
                            color="codGrey"
                            fontFamily="Poppins"
                            fontSize={["16px", "18px"]}
                            fontStyle="normal"
                            fontWeight={400}
                            lineHeight="24px"
                            letterSpacing="-0.32px"
                            textAlign='right'
                            minWidth={100}
                        >
                            {orderSummary?.['sub-total'] ? `$${parseFloat(orderSummary?.['sub-total']).toFixed(2)}` : '-'}
                        </Text>
                    </Flex>
                </>}
            </Box>

            {!!orderSummary?.['discount-total'] && <Box px={2} py={1} sx={{ borderRadius: '12px', background: "linear-gradient(180deg, #E0FFEA 0%, rgba(224, 255, 234, 0.50) 100%)" }}>
                <Flex justifyContent="space-between" my={1}>
                    <Flex alignItems="center">
                        <AiOutlineTag size={24} color="#00611F" />
                        <Text
                            ml={1}
                            color="#00611F"
                            fontSize={16}
                            fontFamily="Poppins"
                            lineHeight="150%"
                            fontWeight={500}
                            letterSpacing="-0.32px"
                            textAlign="left"
                        >
                            You save {orderSummary?.['discount-total'] ? `$${parseFloat(orderSummary?.['discount-total']).toFixed(2)}!` : '-'}
                        </Text>
                    </Flex>

                </Flex>

            </Box>}


            <Box my={1} sx={{
                borderTop: "1px solid rgba(0, 0, 0, 0.05)"
            }} />
            {/* 
            <Flex px={2} justifyContent="space-between" my={1}>
                <Text
                    color="codGrey"
                    fontSize={16}
                    fontFamily="Poppins"
                    lineHeight="150%"
                    fontWeight={isFromReadyPurchase ? 500 : 400}
                    letterSpacing="-0.36px"
                    textAlign="left"
                >
                    Subtotal
                </Text>
                <Text
                    fontFamily="Poppins"
                    fontSize={["16px", "18px"]}
                    fontStyle="normal"
                    fontWeight={500}
                    lineHeight="24px"
                    letterSpacing="-0.36px"

                    textAlign='right'
                    minWidth={100}>
                    {orderSummary?.['sub-total'] ? `$${parseFloat(orderSummary?.['sub-total']).toFixed(2)}` : '-'}
                </Text>
            </Flex> */}
            <Flex
                px={2}
                justifyContent="space-between"
                pb={1}
                mt={2}
            >
                <Text
                    color="codGrey"
                    fontSize={16}
                    fontFamily="Poppins"
                    lineHeight="150%"
                    fontWeight={400}
                    letterSpacing="-0.28px"
                    textAlign="left"
                >
                    Tax
                </Text>
                <Text
                    color="codGrey"
                    fontFamily="Poppins"
                    fontSize={["16px", "18px"]}
                    fontStyle="normal"
                    fontWeight={400}
                    lineHeight="24px"
                    letterSpacing="-0.36px"

                    textAlign='right'
                    minWidth={100}>
                    {isFromReadyPurchase ? "Calculated at checkout" : `${(orderSummary?.['tax-total'] !== null || orderSummary?.['tax-total'] !== undefined) ? '$' + parseFloat(orderSummary?.['tax-total']).toFixed(2) : '-'}`}
                </Text>
            </Flex>

            {!isFromReadyPurchase && <Flex px={2} justifyContent="space-between" py={1}
                sx={{
                    borderTop: '1px solid rgba(0, 0, 0, 0.05)'
                }}
            >
                <Text
                    color="codGrey"
                    fontSize={18}
                    fontFamily="Poppins"
                    lineHeight="150%"
                    fontWeight={600}
                    letterSpacing="-0.36px"
                    textAlign="left"

                >
                    Total
                </Text>
                <Text
                    fontFamily="Poppins"
                    fontSize={18}
                    fontStyle="normal"
                    fontWeight={600}
                    lineHeight="24px"
                    letterSpacing="-0.36px"
                    textAlign='right'
                    minWidth={100}>
                    {(orderSummary?.['grand-total'] !== null || orderSummary?.['grand-total'] !== undefined)  ? `$${parseFloat(orderSummary?.['grand-total']).toFixed(2)}` : '-'}
                </Text>
            </Flex>}
            {/* <Flex justifyContent="end">
            <Flex alignItems="center" px={2} py="4px" sx={{ borderRadius: '12px', background: "linear-gradient(180deg, #E0FFEA 0%, rgba(224, 255, 234, 0.50) 100%)" }}>
                <AiOutlineTag size={24} color="#00611F" />
                <Text
                    px={2}
                    color="#00611F"
                    fontSize={16}
                    fontFamily="Poppins"
                    lineHeight="150%"
                    fontWeight={500}
                    letterSpacing="-0.28px"
                    textAlign="left"
                >
                    Total Savings
                </Text>
                <Text
                    pl={2}
                    fontFamily="Poppins"
                    fontSize={["16px", "18px"]}
                    fontStyle="normal"
                    fontWeight={500}
                    lineHeight="24px"
                    letterSpacing="-0.32px"
                    color="#00611F"
                    textAlign='right'
                    minWidth={100}>
                    ${parseFloat(orderSummary?.['discount-total']).toFixed(2)}
                </Text>
            </Flex>
        </Flex> */}
        </Box>
    </Flex>
}

const OrderComposer = ({
    calculatedPricing,
    quantity,
    setRequiresQuantity,
    isFromGiftGiver,
    firePostMemberEvent,
    orderSummary,
    email,
    setEmail,
    error,
    setError,
    member,
    isFromRedeemCertificate,
    ...props
}) => {

    // useOutsideClick(wrapper, async () => {
    //     if (member?.email !== email) {
    //         const body = formatMemberBody(memberId, { email });
    //         await postMemberIdentifiers(memberId, body, '/identifiers')
    //     }
    // });

    return <Flex flexDirection="column">

        {!props?.showGiftcard && <>
            <Box m="auto" width={['92%', '92%', '600px']} minWidth={['max-width', 480]}>
                <OrderBreakDown isFromReadyPurchase quantity={quantity} orderSummary={orderSummary} calculatedPricing={calculatedPricing} />
                <Text
                    color="#64748B"
                    fontFamily="Poppins"
                    fontSize="15px"
                    fontStyle="italic"
                    fontWeight={400}
                    lineHeight="150%"
                    letterSpacing="-0.3px"
                    mx="16px"
                >
                    {isFromGiftGiver ? '*Prices in USD. Shipping will be charged to your gift recipient when their book is ready to print and ship.' :
                        '*Prices in USD. Shipping will be charged when your book is ready to print and ship.'
                    }
                </Text>
            </Box>
        </>}
    </Flex >
}

export default OrderComposer;